import React from 'react';
import oneAppModuleWrapper from '@americanexpress/one-app/module-wrapper';
import { IntlProvider } from 'react-intl';
import { loadLanguagePack } from '@americanexpress/one-app/ducks';
import { ProgressCircular } from '@americanexpress/dls-react';
import OnboardingForm from '../registration/OnboardingForm';
const InvoiceManagementStart = ({
  languageData,
  locale
}) => {
  if (Object.entries(languageData).length === 0) {
    return /*#__PURE__*/React.createElement(ProgressCircular, null);
  }
  return /*#__PURE__*/React.createElement(IntlProvider, {
    locale: locale,
    messages: languageData
  }, /*#__PURE__*/React.createElement(OnboardingForm, null));
};
export const TestableInvoiceManagementStart = InvoiceManagementStart;
export const loadModuleData = async ({
  store: {
    dispatch
  }
}) => dispatch(loadLanguagePack('invoice-management-start', {
  fallbackLocale: 'en-US'
}));
InvoiceManagementStart.holocron = {
  name: 'invoice-management-start',
  loadModuleData
};
InvoiceManagementStart.displayName = 'InvoiceManagementStart';
export default oneAppModuleWrapper('invoice-management-start')(InvoiceManagementStart);